export const Staff = {
  en: {
    'Search folders and users…': 'Search folders and users…',
    'Show blocked': 'Show blocked',
    'Expand all': 'Expand all',
    'Collapse tree': 'Collapse',
    'No results.': 'No results.',
    'No selection': 'No selection',
    'Select a folder or staff member from the tree on the left to see details.':
      'Select a folder or staff member from the tree on the left to see details.',
    Folder: 'Folder',
    'Staff member': 'Staff member',
    Blocked: 'Blocked',
    Rename: 'Rename',
    Move: 'Move',
    'Move…': 'Move…',
    'Create subfolder': 'Create subfolder',
    'Create user': 'Create user',
    Subfolder: 'Subfolder',
    Block: 'Block',
    Unblock: 'Unblock',
    Close: 'Close',
    Permissions: 'Permissions',
    'Cash register access': 'Cash register access',
    'Cash register access hint':
      'The group may take payments and transfers only through the checked registers. Unchecked registers stay hidden in pickers and reports.',
    'No cash registers in the company.': 'No cash registers in the company.',
    Users: 'Users',
    Reset: 'Reset',
    Subfolders: 'subfolders',
    'direct users': 'direct users',
    'users total': 'users total',
    'Folder has users': 'Folder has users',
    'Cannot delete folder with users': 'Cannot delete: folder contains users.',
    'No direct users in this folder.': 'No direct users in this folder.',
    'Listed: direct children only. Total in subtree:':
      'Listed: direct children only. Total in subtree:',
    'Folder name': 'Folder name',
    'Subfolder name': 'Subfolder name',
    'Edit Folder': 'Edit Folder',
    'Create Folder': 'Create Folder',
    'Create Root Folder': 'Create Root Folder',
    'Create Subfolder': 'Create Subfolder',
    'Parent folder': 'Parent folder',
    'Move Folder': 'Move Folder',
    'Move Users': 'Move Users',
    'Move User': 'Move User',
    'Select destination folder': 'Select destination folder',
    'Target folder': 'Target folder',
    'Confirm deletion': 'Confirm deletion',
    'Delete folder confirm': 'Delete this folder? This cannot be undone.',
    'Block user confirm':
      'Block this user? They will be logged out on their next request.',
    'Block user cleanup reminder':
      'When blocking a user, remember to remove them from the calendar and active services.',
    'Unblock user confirm': 'Unblock this user?',
    'Move user confirm': 'Move this user to the selected folder?',
    'Move users confirm': 'Move the selected users to the selected folder?',
    'User already in folder': 'User is already in this folder',
    'Users already in folder': 'All selected users are already in this folder',
    'Move folder confirm': 'Move this folder to the selected folder?',
    'Cannot move folder depth':
      'Cannot move: would exceed the maximum folder depth of 5.',
    'Cannot create subfolder depth':
      'Cannot create subfolder: maximum folder depth is 5.',
    'Permissions saved': 'Permissions saved',
    'Cash register access saved': 'Cash register access saved',
    'Folder renamed': 'Folder renamed',
    'Folder created': 'Folder created',
    'Folder moved': 'Folder moved',
    'Folder deleted': 'Folder deleted',
    'User created': 'User created',
    'User saved': 'User saved',
    'User moved': 'User moved',
    'User blocked': 'User blocked',
    'User unblocked': 'User unblocked',
    'Users moved': 'Users moved',
    Selected: 'selected',
    'Clear selection': 'Clear selection',
    'Read-only locations': 'Read-only locations',
    'Locations outside your scope are preserved and cannot be removed.':
      'Locations outside your scope are preserved and cannot be removed.',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    Email: 'Email',
    Phone: 'Phone',
    Login: 'Login',
    Password: 'Password',
    'Confirm Password': 'Confirm Password',
    Locations: 'Locations',
    Photo: 'Photo',
    'Photo hint':
      'Client-facing photo. Shown to clients for specialists available for online booking.',
    'Client description': 'Client description',
    'Client description hint':
      'Client-facing description. Shown to clients for specialists available for online booking.',
    Specialist: 'Specialist',
    'Specialist hint':
      'Staff who provide services to clients (trainers, etc.). Specialists can be booked online.',
    'Available for online booking': 'Available for online booking',
    'Available for online booking hint':
      'Clients can book this specialist online. Available for specialists only.',
    'Online booking': 'Online booking',
    'Create Staff User': 'Create Staff User',
    'Edit Staff User': 'Edit Staff User',
    'Edit form note':
      'Changes apply on the next page load for the affected user.',
    'General info': 'General info',
    'Work schedule': 'Work schedule',
    'Work schedule saves independently':
      'Every change here is saved immediately — the schedule is not part of the staff member form.',
    'Failed to load the work schedule': 'Failed to load the work schedule',
    'Copy interval': 'Copy interval',
    'Clear the day': 'Clear the day',
    'Clear the day confirm':
      'Remove every working hour of this weekday at the selected location?',
    'Clear the time': 'Clear the time',
    'Clear the time confirm':
      'Remove every working hour of this date at the selected location?',
    'Delete interval': 'Delete interval',
    'Weekly template': 'Weekly template',
    'Date exceptions': 'Date exceptions',
    'Reset to weekly template': 'Reset to weekly template',
    'This date follows the weekly template':
      'This date follows the weekly template. Editing it creates an exception.',
    'Work schedule needs a location':
      'A work schedule is kept per location. Assign at least one location to this staff member first — use Edit.',
    Location: 'Location',
    'Another location': 'Another location',
    'Schedule type': 'Schedule type',
    'weekday short: monday': 'Mon',
    'weekday short: tuesday': 'Tue',
    'weekday short: wednesday': 'Wed',
    'weekday short: thursday': 'Thu',
    'weekday short: friday': 'Fri',
    'weekday short: saturday': 'Sat',
    'weekday short: sunday': 'Sun',
    'weekday: monday': 'Monday',
    'weekday: tuesday': 'Tuesday',
    'weekday: wednesday': 'Wednesday',
    'weekday: thursday': 'Thursday',
    'weekday: friday': 'Friday',
    'weekday: saturday': 'Saturday',
    'weekday: sunday': 'Sunday',
    'permission name: company.manage': 'Company',
    'permission description: company.manage':
      'Edit company profile and additional fields. Create and edit locations.',
    'permission name: payments.configure': 'Payments',
    'permission description: payments.configure':
      'Create and edit cashiers, payment cards, online payment keys, and fiscal online registrars.',
    'permission name: payments.manage': 'Cash register operations',
    'permission description: payments.manage':
      'Ring receipts, open and close cashier shifts, create terminal payments, and switch fiscal registrar modes.',
    'permission name: fiscalization.manage': 'Fiscalization — Setup',
    'permission description: fiscalization.manage':
      'Create and edit fiscalization cashiers under Integrations → Fiscalization.',
    'permission name: fiscalization.operate': 'Fiscalization — Operations',
    'permission description: fiscalization.operate':
      'Open and close the shift, run X / Z reports, and issue cash-in / cash-out service receipts from Reception, on the locations the staff member has access to.',
    'permission name: services.manage': 'Services',
    'permission description: services.manage':
      'Create and edit services, online services, and service categories.',
    'permission name: services.sell_hidden':
      'Clients — Sell non-visible services',
    'permission description: services.sell_hidden':
      'Sell services marked as non-visible (hidden from the default sale flow) to clients.',
    'permission name: bookings.configure': 'Bookings — Setup',
    'permission description: bookings.configure':
      'Create and edit booking services, booking providers, recurring events, booking settings, and email templates.',
    'permission name: bookings.manage': 'Bookings — Operations',
    'permission description: bookings.manage':
      'View and operate on bookings in the calendar and the "All bookings" tab.',
    'permission name: booking_providers.availability.manage':
      'Bookings — Provider time',
    'permission description: booking_providers.availability.manage':
      'Manage working hours and availability schedules of booking providers.',
    'permission name: promotions.manage': 'Promotions',
    'permission description: promotions.manage': 'Create and edit promotions.',
    'permission name: clients.manage': 'Clients — Manage clients',
    'permission description: clients.manage':
      'View the clients list, create new clients, and edit existing client records.',
    'permission name: clients.blacklist.manage': 'Clients — Manage black list',
    'permission description: clients.blacklist.manage':
      'Add a client to the black list or remove them from it. Requires "Manage clients" to edit the client.',
    'permission name: certificates.manage': 'Certificates',
    'permission description: certificates.manage':
      'Sell, redeem, and print receipts for paper certificates.',
    'permission name: certificates.online.manage': 'Online certificates',
    'permission description: certificates.online.manage':
      'Configure online certificate offerings.',
    'permission name: staff.manage': 'Staff',
    'permission description: staff.manage':
      'Create and block users, manage permission groups and assign permission keys to them. When assigning locations to a user, the actor can only pick from the locations they themselves are linked to.',
    'permission name: logs.orders.view': 'Logs — Orders',
    'permission description: logs.orders.view': 'View the orders info log.',
    'permission name: logs.users.view': 'Logs — Users',
    'permission description: logs.users.view': 'View user activity logs.',
    'permission name: logs.service_history.view': 'Logs — Service history',
    'permission description: logs.service_history.view':
      'View the service-user history log.',
    'permission name: reports.view': 'Reports — Analytics',
    'permission description: reports.view':
      'Access to the analytics reports: general stats, income, subscriptions, service ratings, returned clients.',
    'permission name: reports.cash_flow.view': 'Reports — Cash Flow',
    'permission description: reports.cash_flow.view':
      'View the Cash Flow report: money that moved through cash registers over a period, itemised by article.',
    'permission name: reports.profit_and_loss.view': 'Reports — Profit & Loss',
    'permission description: reports.profit_and_loss.view':
      'View the Profit & Loss report: recognised revenue less discounts, COGS and operating expenses.',
    'permission name: reports.operations_journal.view':
      'Reports — Operations Journal',
    'permission description: reports.operations_journal.view':
      'View the operations journal: the ledger transaction feed with its filters.',
    'permission name: reports.cash_balances.view': 'Reports — Cash balances',
    'permission description: reports.cash_balances.view':
      'View the cash balances report: money held in each cash register.',
    'permission name: reports.outstanding_obligations.view':
      'Reports — Outstanding obligations',
    'permission description: reports.outstanding_obligations.view':
      'View the outstanding obligations report: services sold but not yet delivered.',
    'permission name: reports.recognition_runs.view':
      'Reports — Recognition Runs',
    'permission description: reports.recognition_runs.view':
      'View the recognition run log: when the revenue-recognition crons ran and with what result. Re-running a recognition stays restricted.',
    'permission name: reports.certificates.view':
      'Reports — Certificate Reports',
    'permission description: reports.certificates.view':
      'View the certificate reports: sold, redeemed and expired certificates.',
    'permission name: reports.fiscalization.view': 'Reports — Fiscalization',
    'permission description: reports.fiscalization.view':
      'View the fiscalization report: every receipt sent to the provider and what the provider answered.',
  },
  uk: {
    'Search folders and users…': 'Пошук папок і користувачів…',
    'Show blocked': 'Показати заблокованих',
    'Expand all': 'Розгорнути все',
    'Collapse tree': 'Згорнути',
    'No results.': 'Нічого не знайдено.',
    'No selection': 'Нічого не вибрано',
    'Select a folder or staff member from the tree on the left to see details.':
      'Виберіть папку або співробітника в дереві зліва, щоб переглянути деталі.',
    Folder: 'Папка',
    'Staff member': 'Співробітник',
    Blocked: 'Заблокований',
    Rename: 'Перейменувати',
    Move: 'Перемістити',
    'Move…': 'Перемістити…',
    'Create subfolder': 'Створити підпапку',
    'Create user': 'Створити користувача',
    Subfolder: 'Підпапка',
    Block: 'Заблокувати',
    Unblock: 'Розблокувати',
    Close: 'Закрити',
    Permissions: 'Дозволи',
    'Cash register access': 'Доступ до кас',
    'Cash register access hint':
      'Група може приймати оплати та перекази лише через позначені каси. Непозначені каси не показуються ні в списках вибору, ні у звітах.',
    'No cash registers in the company.': 'У компанії немає кас.',
    Users: 'Користувачі',
    Reset: 'Скинути',
    Subfolders: 'підпапок',
    'direct users': 'користувачів безпосередньо',
    'users total': 'користувачів загалом',
    'Folder has users': 'У папці є користувачі',
    'Cannot delete folder with users':
      'Неможливо видалити: у папці є користувачі.',
    'No direct users in this folder.':
      'У цій папці немає користувачів безпосередньо.',
    'Listed: direct children only. Total in subtree:':
      'Показано лише прямих нащадків. Усього в піддереві:',
    'Folder name': 'Назва папки',
    'Subfolder name': 'Назва підпапки',
    'Edit Folder': 'Редагувати папку',
    'Create Folder': 'Створити папку',
    'Create Root Folder': 'Створити кореневу папку',
    'Create Subfolder': 'Створити підпапку',
    'Parent folder': 'Батьківська папка',
    'Move Folder': 'Перемістити папку',
    'Move Users': 'Перемістити користувачів',
    'Move User': 'Перемістити користувача',
    'Select destination folder': 'Виберіть папку призначення',
    'Target folder': 'Папка призначення',
    'Confirm deletion': 'Підтвердити видалення',
    'Delete folder confirm': 'Видалити цю папку? Цю дію не можна скасувати.',
    'Block user confirm':
      'Заблокувати користувача? На наступному запиті він буде розлогінений.',
    'Block user cleanup reminder':
      'Блокуючи користувача, не забудьте видалити його з календаря та активних сервісів.',
    'Unblock user confirm': 'Розблокувати користувача?',
    'Move user confirm': 'Перемістити користувача до вибраної папки?',
    'Move users confirm':
      'Перемістити вибраних користувачів до вибраної папки?',
    'User already in folder': 'Користувач уже в цій папці',
    'Users already in folder': 'Усі вибрані користувачі вже в цій папці',
    'Move folder confirm': 'Перемістити папку до вибраної папки?',
    'Cannot move folder depth':
      'Неможливо перемістити: перевищено максимальну глибину 5 рівнів.',
    'Cannot create subfolder depth':
      'Неможливо створити підпапку: максимальна глибина 5 рівнів.',
    'Permissions saved': 'Дозволи збережено',
    'Cash register access saved': 'Доступ до кас збережено',
    'Folder renamed': 'Папку перейменовано',
    'Folder created': 'Папку створено',
    'Folder moved': 'Папку переміщено',
    'Folder deleted': 'Папку видалено',
    'User created': 'Користувача створено',
    'User saved': 'Користувача збережено',
    'User moved': 'Користувача переміщено',
    'User blocked': 'Користувача заблоковано',
    'User unblocked': 'Користувача розблоковано',
    'Users moved': 'Користувачів переміщено',
    Selected: 'вибрано',
    'Clear selection': 'Скасувати вибір',
    'Read-only locations': 'Локації лише для перегляду',
    'Locations outside your scope are preserved and cannot be removed.':
      'Локації поза вашим доступом збережені і не можуть бути зняті.',
    'First Name': "Ім'я",
    'Last Name': 'Прізвище',
    Email: 'Email',
    Phone: 'Телефон',
    Login: 'Логін',
    Password: 'Пароль',
    'Confirm Password': 'Підтвердити пароль',
    Locations: 'Локації',
    Photo: 'Фото',
    'Photo hint':
      'Фото для клієнтів. Показується клієнтам для фахівців, доступних для онлайн-запису.',
    'Client description': 'Опис для клієнтів',
    'Client description hint':
      'Опис для клієнтів. Показується клієнтам для фахівців, доступних для онлайн-запису.',
    Specialist: 'Фахівець',
    'Specialist hint':
      'Персонал, який надає послуги клієнтам (тренери тощо). Для фахівців доступне онлайн-бронювання.',
    'Available for online booking': 'Доступний для онлайн-запису',
    'Available for online booking hint':
      'Клієнт зможе записатися до цього фахівця онлайн. Доступно лише для фахівців.',
    'Online booking': 'Онлайн-запис',
    'Create Staff User': 'Створити співробітника',
    'Edit Staff User': 'Редагувати співробітника',
    'Edit form note':
      'Зміни набудуть чинності після наступного завантаження сторінки для цього користувача.',
    'General info': 'Загальна інформація',
    'Work schedule': 'Графік роботи',
    'Work schedule saves independently':
      'Кожна зміна тут зберігається одразу — графік не є частиною форми співробітника.',
    'Failed to load the work schedule': 'Не вдалося завантажити графік роботи',
    'Copy interval': 'Копіювати інтервал',
    'Clear the day': 'Очистити день',
    'Clear the day confirm':
      'Прибрати всі робочі години цього дня тижня у вибраній локації?',
    'Clear the time': 'Очистити час',
    'Clear the time confirm':
      'Прибрати всі робочі години цієї дати у вибраній локації?',
    'Delete interval': 'Видалити інтервал',
    'Weekly template': 'Тижневий шаблон',
    'Date exceptions': 'Винятки на дату',
    'Reset to weekly template': 'Скинути до шаблону',
    'This date follows the weekly template':
      'Ця дата підпорядковується тижневому шаблону. Редагування створить виняток.',
    'Work schedule needs a location':
      'Графік роботи ведеться по локаціях. Спочатку призначте співробітнику хоча б одну локацію — через «Редагувати».',
    Location: 'Локація',
    'Another location': 'Інша локація',
    'Schedule type': 'Тип графіка',
    'weekday short: monday': 'Пн',
    'weekday short: tuesday': 'Вт',
    'weekday short: wednesday': 'Ср',
    'weekday short: thursday': 'Чт',
    'weekday short: friday': 'Пт',
    'weekday short: saturday': 'Сб',
    'weekday short: sunday': 'Нд',
    'weekday: monday': 'Понеділок',
    'weekday: tuesday': 'Вівторок',
    'weekday: wednesday': 'Середа',
    'weekday: thursday': 'Четвер',
    'weekday: friday': "П'ятниця",
    'weekday: saturday': 'Субота',
    'weekday: sunday': 'Неділя',
    'permission name: company.manage': 'Компанія',
    'permission description: company.manage':
      'Редагування профілю компанії та додаткових полів. Створення і редагування локацій.',
    'permission name: payments.configure': 'Платежі',
    'permission description: payments.configure':
      'Створення і редагування касирів, платіжних карток, ключів онлайн-оплати та фіскальних онлайн-реєстраторів.',
    'permission name: payments.manage': 'Операції з касовим апаратом',
    'permission description: payments.manage':
      'Друк чеків, відкриття та закриття зміни касира, створення терміналу платежів, перемикання режимів фіскального реєстратора.',
    'permission name: fiscalization.manage': 'Фіскалізація — Налаштування',
    'permission description: fiscalization.manage':
      'Створення і редагування кас фіскалізації в розділі Інтеграції → Фіскалізація.',
    'permission name: fiscalization.operate': 'Фіскалізація — Операції',
    'permission description: fiscalization.operate':
      'Відкриття і закриття зміни, X- та Z-звіти, службові чеки внесення / видачі готівки в розділі Ресепшн — на локаціях, доступних співробітнику.',
    'permission name: services.manage': 'Сервіси',
    'permission description: services.manage':
      'Створення і редагування сервісів, онлайн-сервісів та категорій сервісів.',
    'permission name: services.sell_hidden':
      'Клієнти — Продаж прихованих сервісів',
    'permission description: services.sell_hidden':
      'Продаж сервісів, позначених як приховані (не показуються у стандартному потоці продажу), клієнтам.',
    'permission name: bookings.configure': 'Бронювання — Налаштування',
    'permission description: bookings.configure':
      'Створення і редагування сервісів бронювання, провайдерів бронювання, повторюваних подій, налаштувань бронювання та поштових шаблонів.',
    'permission name: bookings.manage': 'Бронювання — Операції',
    'permission description: bookings.manage':
      'Перегляд та операції з бронюваннями у календарі та на вкладці «Усі бронювання».',
    'permission name: booking_providers.availability.manage':
      'Бронювання — Час провайдера',
    'permission description: booking_providers.availability.manage':
      'Управління робочими годинами та розкладом доступності провайдерів бронювання.',
    'permission name: promotions.manage': 'Промоакції',
    'permission description: promotions.manage':
      'Створення і редагування промоакцій.',
    'permission name: clients.manage': 'Клієнти — Управління клієнтами',
    'permission description: clients.manage':
      'Перегляд списку клієнтів, створення нових клієнтів та редагування існуючих карток клієнтів.',
    'permission name: clients.blacklist.manage':
      'Клієнти — Управління чорним списком',
    'permission description: clients.blacklist.manage':
      'Додавання клієнта до чорного списку та видалення з нього. Для редагування картки потрібен дозвіл «Управління клієнтами».',
    'permission name: certificates.manage': 'Сертифікати',
    'permission description: certificates.manage':
      'Продаж, погашення та друк чеків паперових сертифікатів.',
    'permission name: certificates.online.manage': 'Онлайн-сертифікати',
    'permission description: certificates.online.manage':
      'Налаштування онлайн-сертифікатів.',
    'permission name: staff.manage': 'Персонал',
    'permission description: staff.manage':
      'Створення та блокування користувачів, керування групами прав доступу та призначення ключів дозволів до них. Під час призначення локацій актор може обрати лише ті локації, до яких він сам прив’язаний.',
    'permission name: logs.orders.view': 'Логи — Замовлення',
    'permission description: logs.orders.view':
      'Перегляд логу інформації про замовлення.',
    'permission name: logs.users.view': 'Логи — Користувачі',
    'permission description: logs.users.view':
      'Перегляд логів активності користувачів.',
    'permission name: logs.service_history.view': 'Логи — Історія сервісів',
    'permission description: logs.service_history.view':
      'Перегляд логу історії використання сервісів клієнтами.',
    'permission name: reports.view': 'Звіти — Аналітика',
    'permission description: reports.view':
      'Доступ до аналітичних звітів: загальна статистика, дохід, абонементи, рейтинг послуг, повернені клієнти.',
    'permission name: reports.cash_flow.view': 'Звіти — Рух грошових коштів',
    'permission description: reports.cash_flow.view':
      'Перегляд звіту «Рух грошових коштів»: гроші, що пройшли через каси за період, у розрізі статей.',
    'permission name: reports.profit_and_loss.view':
      'Звіти — Прибутки та витрати',
    'permission description: reports.profit_and_loss.view':
      'Перегляд звіту «Прибутки та витрати»: визнаний дохід за вирахуванням знижок, собівартості та операційних витрат.',
    'permission name: reports.operations_journal.view':
      'Звіти — Журнал операцій',
    'permission description: reports.operations_journal.view':
      'Перегляд журналу операцій: стрічка проводок з фільтрами.',
    'permission name: reports.cash_balances.view': 'Звіти — Залишки в касах',
    'permission description: reports.cash_balances.view':
      'Перегляд звіту про залишки коштів у кожній касі.',
    'permission name: reports.outstanding_obligations.view':
      'Звіти — Невиконані зобов’язання',
    'permission description: reports.outstanding_obligations.view':
      'Перегляд звіту про невиконані зобов’язання: продані, але ще не надані послуги.',
    'permission name: reports.recognition_runs.view':
      'Звіти — Визнання виручки',
    'permission description: reports.recognition_runs.view':
      'Перегляд логу запусків визнання виручки: коли відпрацювали крони та з яким результатом. Повторний запуск лишається обмеженим.',
    'permission name: reports.certificates.view': 'Звіти — Обіг сертифікатів',
    'permission description: reports.certificates.view':
      'Перегляд звітів за сертифікатами: продані, використані та прострочені сертифікати.',
    'permission name: reports.fiscalization.view': 'Звіти — Фіскалізація',
    'permission description: reports.fiscalization.view':
      'Перегляд звіту з фіскалізації: усі чеки, надіслані провайдеру, та відповіді провайдера.',
  },
};
